import { ContainerComponent } from './DynamicComponent'

export type CtaVariant = 'loggedOut' | 'ineligibleCart' | 'loggedIn'

export type CtaSubVariant =
  | 'DEFAULT'
  | 'IN_PROGRESS'
  | 'ACCEPTED'
  | 'REJECTED'
  | 'ACKNOWLEDGED_NULLIFIED'
  | 'LIMIT_REACHED'

/**
 * JSON configuration for the different CTA states
 */
export type CtaConfiguration = {
  loggedOut: ContainerComponent
  ineligibleCart: ContainerComponent
  loggedIn: {
    DEFAULT: ContainerComponent
    IN_PROGRESS: ContainerComponent
    ACCEPTED: ContainerComponent
    REJECTED: ContainerComponent
    ACKNOWLEDGED_NULLIFIED?: ContainerComponent
    LIMIT_REACHED: ContainerComponent
  }
}

/**
 * FIXME: remove once we confirm NULLIFY_EXPIRED no longer applies
 */
export const enum CtaError {
  GENERIC_ERROR = 'GENERIC_ERROR',
  NULLIFY_EXPIRED = 'NULLIFY_EXPIRED',
  INIT_ERROR = 'INIT_ERROR',
  NONE = 'NONE',
}
